import React from "react";
import CustomPrintOutQuotation from "../../../../../partials/content/CustomPrintOutQuotation";
const QuotationPrintOut = ({ quotation }) => {
  return (
    <React.Fragment>
      <CustomPrintOutQuotation quotationID={quotation.ID} />
    </React.Fragment>
  );
};

export default QuotationPrintOut;
